"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));
var _preloginMetricsBatcher = _interopRequireDefault(require("./prelogin-metrics-batcher"));
var ClientMetricsPreloginBatcher = _preloginMetricsBatcher.default.extend({
  namespace: 'Metrics',
  /**
   * Prepare item
   * @param {any} item
   * @returns {Promise<any>}
   */
  prepareItem: function prepareItem(item) {
    // Add more defaults to payload when the clientmetrics endpoint evolves to support richer payloads
    return _promise.default.resolve(item);
  },
  /**
   * Prepare request, add time sensitive date etc.
   * @param {any[]} queue
   * @returns {Promise<any[]>}
   */
  prepareRequest: function prepareRequest(queue) {
    return _promise.default.resolve(queue);
  }
});
var _default = exports.default = ClientMetricsPreloginBatcher;
//# sourceMappingURL=client-metrics-prelogin-batcher.js.map
